import { Tooltip } from "react-tooltip";

/**
 * @deprecated
 * Use Tooltip component instead
 */
export function TooltipRoot() {
  return (
    <Tooltip
      className="vega-react-tooltip"
      id="vega-tooltip-root"
      opacity={1}
    />
  );
}
